import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import LogoCloud from "@/components/landing/LogoCloud";
import LiveCounter from "@/components/landing/LiveCounter";
import PainPoints from "@/components/landing/PainPoints";
import Differentiator from "@/components/landing/Differentiator";
import ROICalculator from "@/components/landing/ROICalculator";
import Features from "@/components/landing/Features";
import KeywordHighlight from "@/components/landing/KeywordHighlight";
import HowItWorks from "@/components/landing/HowItWorks";
import CompareTable from "@/components/landing/CompareTable";
import CaseStudy from "@/components/landing/CaseStudy";
import Testimonials from "@/components/landing/Testimonials";
import CostOfInaction from "@/components/landing/CostOfInaction";
import Education from "@/components/landing/Education";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";
import SEOHead from "@/components/SEOHead";
import { useTranslation } from "@/i18n";

const faqStructuredData = [
  { q: "¿Cómo mejora Rankaro el SEO de mi WordPress y WooCommerce?", a: "Rankaro usa inteligencia artificial para generar automáticamente títulos, descripciones y meta tags optimizados para cada producto y categoría de tu tienda WordPress con WooCommerce." },
  { q: "¿Necesito conocimientos de SEO para usar Rankaro?", a: "No. Rankaro está diseñado para que cualquier dueño de tienda pueda optimizar su SEO sin conocimientos técnicos. La IA se encarga de todo." },
  { q: "¿Es compatible con Yoast SEO y RankMath?", a: "Sí. Rankaro es compatible con Yoast SEO, RankMath y All in One SEO. Escribe directamente en los meta campos de cada plugin." },
  { q: "¿Puedo revisar el contenido antes de aplicarlo?", a: "Sí. Rankaro genera propuestas SEO que puedes revisar, editar y aprobar antes de aplicarlas a tu tienda." },
  { q: "¿Cuántos productos puedo optimizar gratis?", a: "El plan gratuito incluye 5 productos al mes. Para tiendas más grandes, ofrecemos planes desde $19/mes." },
  { q: "¿El contenido generado es único?", a: "Sí. Cada texto es generado de forma única para tu producto específico, evitando contenido duplicado." },
];

const Index = () => {
  const { t } = useTranslation();

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqStructuredData.map(item => ({
      "@type": "Question",
      "name": item.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.a,
      },
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Herramienta SEO Autopilot para WordPress y WooCommerce | Rankaro"
        description="La herramienta SEO para WordPress y WooCommerce con IA. Genera títulos, descripciones y meta tags optimizados en minutos. Prueba gratis."
        canonical="https://rankaro.io"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Header />
      <main>
        <Hero />
        <LogoCloud />
        <LiveCounter />
        <PainPoints />
        <Differentiator />
        <ROICalculator />
        <Features />
        <KeywordHighlight />
        <HowItWorks />
        <CompareTable />
        <CaseStudy />
        <Testimonials />
        <CostOfInaction />
        <Pricing />
        <Education />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
